import { companyHasSinglePermission, userHasSinglePermission } from 'util/PermissionsUtils';
import { Permission as P } from 'common/models/Permissions';

export const AllowAdvertsModule = () =>
  userHasSinglePermission(P.Adverts) && companyHasSinglePermission(P.Adverts);
export const AllowAdvertsAddEdit = () =>
  userHasSinglePermission(P.AdvertsAddEdit) && companyHasSinglePermission(P.AdvertsAddEdit);
export const AllowAdvertsDelete = () =>
  userHasSinglePermission(P.AdvertsDelete) && companyHasSinglePermission(P.AdvertsDelete);
export const AllowAdvertsReportsAccess = () => userHasSinglePermission(P.AdvertsReports);
